import React, { forwardRef } from "react";
import { TimePicker } from "antd";
import moment from "moment";

const TimePickerRange = props => {
  const { start, end, disabled, form } = props;

  const { getFieldDecorator } = form;

  const Hours = Array.from(Array(24), (v, k) => k);
  const Minutes = Array.from(Array(60), (v, k) => k);
  const Seconds = Array.from(Array(60), (v, k) => k);

  const disEndHour = () => {
    const { getFieldsValue } = form;
    const { startTime } = getFieldsValue();
    if (startTime) {
      const h = startTime.hour();
      return Hours.slice(0, h);
    }
    return [];
  };

  const disEndMinute = h => {
    const { getFieldsValue } = form;
    const { startTime } = getFieldsValue();
    if (startTime) {
      if (h > startTime.hour()) return [];
      const m = startTime.minute();
      return Minutes.slice(0, m);
    }
    return [];
  };

  const disEndSeconds = (h, m) => {
    const { getFieldsValue } = form;
    const { startTime } = getFieldsValue();
    if (startTime) {
      if (h > startTime.hour()) return [];
      if (m > startTime.minute()) return [];
      const s = startTime.second();
      return Seconds.slice(0, s);
    }
    return [];
  };

  const disStartHour = () => {
    const { getFieldsValue } = form;
    const { endTime } = getFieldsValue();
    if (endTime) {
      const h = endTime.hour();
      return Hours.slice(h + 1, Hours.length);
    }
    return [];
  };

  const disStartMinute = h => {
    const { getFieldsValue } = form;
    const { endTime } = getFieldsValue();
    if (endTime) {
      if (h < endTime.hour()) return [];
      const m = endTime.minute();
      return Minutes.slice(m + 1, Minutes.length);
    }
    return [];
  };

  const disStartSeconds = (h, m) => {
    const { getFieldsValue } = form;
    const { endTime } = getFieldsValue();
    if (endTime) {
      if (h < endTime.hour()) return [];
      if (m < endTime.minute()) return [];
      const s = endTime.second();
      return Seconds.slice(s + 1, Seconds.length);
    }
    return [];
  };

  return (
    <>
      {getFieldDecorator("startTime", {
        initialValue: start
      })(
        <TimePicker
          allowClear={false}
          disabled={disabled}
          disabledHours={disStartHour}
          disabledMinutes={disStartMinute}
          disabledSeconds={disStartSeconds}
          defaultOpenValue={moment("00:00:00", "HH:mm:ss")}
        />
      )}
      <span style={{ margin: "0 12px" }}>~</span>
      {getFieldDecorator("endTime", {
        initialValue: end
      })(
        <TimePicker
          allowClear={false}
          disabled={disabled}
          disabledHours={disEndHour}
          disabledMinutes={disEndMinute}
          disabledSeconds={disEndSeconds}
          defaultOpenValue={moment("23:59:59", "HH:mm:ss")}
        />
      )}
    </>
  );
};

export default forwardRef(TimePickerRange);
